import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
`;

export const Picker = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;

    > h2 {
        margin-bottom: ${({ theme }) => theme.base.spacing[6]};
    }

    > div[role='radiogroup'] {
        padding-bottom: ${({ theme }) => theme.base.spacing[2]};
        border-bottom: ${({ theme }) => `0.5px solid ${theme.base.color.separator}`};
        margin-bottom: ${({ theme }) => theme.base.spacing[6]};
    }
`;

export const BottomBar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: ${({ theme }) => theme.base.spacing[4]};
`;
